import { MarwisService } from './marwis.service';

import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

export const MODULES = [CommonModule, TranslateModule];

@Component({
  selector: 'app-marwis-legend',
  templateUrl: './marwis-legend.component.html',
  styleUrls: ['./marwis-legend.component.scss'],
  imports: [...MODULES],
})
export class MarwisLegendComponent {
  public marwisService = inject(MarwisService);

  parameter = input<string>();

  radarLegendNames = ['RAIN', 'SNOWrainGRAUPEL', 'HailSnow', 'ICERAIN'];

  translationWinter = [
    'OTHER',
    'WETNESS',
    'RIME',
    'FREEZING_WETNESS',
    'FREEZING_RAIN',
    'SNOW',
  ];
  conditions = [
    [0, 19, 19],
    [2, 3, 4],
    [5, 9, 14],
    [6, 10, 15],
    [7, 11, 16],
    [8, 13, 18],
    [1, 12, 17],
  ];

  roadTemperatures = ['> 3', '<= 3', '<= 1', '<= 0', '<= -6', '<= -13'];
  roadWarnLevels = ['Stufe 0', 'Stufe 1', 'Stufe 2', 'Stufe 3'];
}
